import { render, staticRenderFns } from "./dap-submitted-project-retail.page.vue?vue&type=template&id=5c4c9c70&scoped=true"
import script from "./dap-submitted-project-retail.page.vue?vue&type=script&lang=ts"
export * from "./dap-submitted-project-retail.page.vue?vue&type=script&lang=ts"
import style0 from "./dap-submitted-project-retail.page.vue?vue&type=style&index=0&id=5c4c9c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4c9c70",
  null
  
)

export default component.exports